import { User } from '@auth0/auth0-spa-js'
import React from 'react'
import { NavLink } from 'react-router-dom'
import { FlexContainer } from '../../FlexContainer'
import ProfileMenu from '../ProfileMenu'

interface ProfileMenuContainerProps {
  isLoading?: boolean
  isAuthenticated?: boolean
  logout?: ({ returnTo }: { returnTo: string }) => void
  user?: User
  isSettingsAllowed: boolean
}

export const ProfileMenuContainer: React.FC<ProfileMenuContainerProps> = ({
  isLoading,
  isAuthenticated,
  logout,
  user,
  isSettingsAllowed,
}: ProfileMenuContainerProps) => {
  if (isLoading && !isAuthenticated) {
    return <NavLink to={'/login'}>Login</NavLink>
  }

  return (
    <FlexContainer align="center" shrink={false}>
      <ProfileMenu
        logout={() => {
          if (logout) {
            logout({ returnTo: window.location.origin + '/login' } as { returnTo: string })
          }
        }}
        user={user as unknown as User}
        isSettingsAllowed={isSettingsAllowed}
      />
    </FlexContainer>
  )
}
